import './CardSection.scss';
import { useState, ReactNode } from 'react';
import { MdExpandMore, MdExpandLess, MdClose, MdEdit } from 'react-icons/md';
import { Form } from 'react-bootstrap';
import { IconButton } from '@Components/IconButton/IconButton';
import { DashboardGrid } from './DashboardGrid';
import { DashboardSection } from './dashboard-types';
import { DropHandler } from './drag/DragContext';

interface CardSectionProps {
  section: DashboardSection;
  isEditMode: boolean;
  onRemove: (id: string) => void;
  onUpdateTitle: (id: string, title: string) => void;
  onDrop: DropHandler;
  cardIds: string[];
  children?: ReactNode;
}

export const CardSection = ({
  section,
  isEditMode,
  onRemove,
  onUpdateTitle,
  onDrop,
  cardIds,
  children
}: CardSectionProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [draftTitle, setDraftTitle] = useState(section.title);

  const commitTitle = () => {
    onUpdateTitle(section.id, draftTitle.trim() || section.title);
    setIsEditingTitle(false);
  };

  return (
    <div className='card-section'>
      <div className='card-section-header'>
        <IconButton onClick={() => setIsOpen(o => !o)}>
          {isOpen ? <MdExpandLess /> : <MdExpandMore />}
        </IconButton>
        {isEditingTitle ? (
          <Form.Control
            autoFocus
            value={draftTitle}
            onChange={e => setDraftTitle(e.target.value)}
            onBlur={commitTitle}
            onKeyDown={e => e.key === 'Enter' && commitTitle()}
            className='card-section-title-input'
          />
        ) : (
          <span className='card-section-title'>{section.title}</span>
        )}
        {isEditMode && (
          <div className='card-section-actions'>
            <IconButton onClick={() => setIsEditingTitle(true)}>
              <MdEdit />
            </IconButton>
            <IconButton onClick={() => onRemove(section.id)}>
              <MdClose />
            </IconButton>
          </div>
        )}
      </div>
      {isOpen && (
        <DashboardGrid zoneId={section.id} onDrop={onDrop} cardIds={cardIds}>
          {children}
        </DashboardGrid>
      )}
    </div>
  );
};
